<template>
    <div :class="['container', { 'container-dark': theme_dark }]">
      <input type="file" id="___file_upload" ref="referenceUpload" accept="image/*" @change="upload" />
      <div class="nav-top">
        <div class="nav-left" @click="back()">
          <img src="../../assets/img/返回箭头.png" class="nav-img" />
          <span class="nav-lable"></span>
        </div>
        <div class="nav-middle">用户反馈</div>
        <div class="nav-right">
          <span class="nav-lable" @click="goto_complain_history()">历史</span>
          <img src="../../assets/img/发布.png" class="nav-img none" />
        </div>
      </div>

      <div class="content">
        <div class="complain-block">
          <div class="describe-block ub ub-ver">
            <textarea contenteditable="true" v-model="txt" placeholder="问题描述" class="describe-text"></textarea>
          </div>

          <div class="note-lb"><span>请你留下宝贵的意见，我们将努力改进！</span></div>

          <div class="line"></div>

          <div class="screenshots-block ub ub-ver">
            <div class="ub ub-pc ub-ps">
              <span class="font-color">问题截图</span>
              <span class="font-color">（选填）</span>
            </div>
            <div class="ub ">
              <li v-for="(i,index) in ayy_pic" :key="index" class="screenshots-div ub ub-ac ub-pc ub-ver ">
                <div class="remove ub ub-pc ub-ac" @click="remove_pic(index)">×</div>
                <img :src="i" class="face-img" @click="show_full(i)"/>
              </li>
              <div v-show="ayy_pic.length<3" class="screenshots-div ub ub-ver ub-pc ub-ac" @click="upload_img()">
                <img src="../../assets/img/上传截图.png" class="describe-upload-img" />
                <span class="describe-upload-name">上传截图</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="gift-tousu-tip ub ub-ac">
         <span>如果对送出去的礼物有异议，可点击<a @click="goto_gift_tousu()">“礼物投诉”</a>进行申诉</span>
      </div>

      <div class="ub ub-ac ub-pc">
        <div class="submit-btn ub ub-ac ub-pc" @click="save()"><span>提交</span></div>
      </div>

      <alert ref="myConfirm"></alert>

      <full_pic ref="myFullPic"></full_pic>
    </div>
  </template>

  <script>
  import Exif from "exif-js";
  import * as tool from "../../api/common";
  import Alert from "../../components/Alert.vue";
  import full_pic from "../../components/Full_Pic.vue";
  import { mapMutations, mapActions } from "vuex";
  export default {
    components: {
      alert: Alert,
      full_pic: full_pic,
    },
    data() {
      return {
        txt: "",
        ayy_pic: [],
        theme_dark: false
      };
    },
    mounted() {
      //切换深色模式
      this.theme_dark = tool.is_theme_dark(this);
    },

    methods: {
      ...mapMutations(["get", "post", "post2"]), //引入方法
      back() {
        this.$router.go(-1); //返回上一层
      },
      goto_gift_tousu() {
        this.$router.push({ name: "gift_tousu" });
      },
      goto_complain_history() {
        this.$router.push({ name: "complain_history" });
      },
      save() {
        var txt = this.txt;
        if (txt == "") {
          //会员提示
          this.$toast.center("投诉反馈信息不能为空哦");
          return false;
        }

        var uid = this.$store.state.uid;
        var data_send = {
          txt: txt,
          pic: this.ayy_pic,
        };
        var strsend = JSON.stringify(data_send);

        var self = this;
        this.post({
          url: "/App/TouSu_Save",
          data: { uid: uid, data: strsend },
          success: function (serve_data) {
            self.$toast.center("您的投诉反馈信息已提交，请等待平台审核。");
            self.txt = "";
            self.ayy_pic = [];

            var bll_id = serve_data.id || "";
            var msg = {
                  "txt": "用户反馈",
                  "desc": "",
                  "id": bll_id
            }
            tool.send_check_msg(self,"check_feedback",msg,true);
          },
        });
      },

      upload_img() {
        //触发input的change事件
        var ie =
          navigator.appName == "Microsoft Internet Explorer" ? true : false;
        if (ie) {
          document.getElementById("___file_upload").click();
        } else {
          var a = document.createEvent("MouseEvents"); //FF的处理
          a.initEvent("click", true, true);
          document.getElementById("___file_upload").dispatchEvent(a);
        }
      },
      upload(e) {
        let files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.picValue = files[0];

        var arrExt = [".png", ".jpg", ".jpeg", ".gif", ".bmp"];
        var file_name = this.picValue.name;
        var fileExt = file_name.substr(file_name.lastIndexOf(".")).toLowerCase();

        if (arrExt.indexOf(fileExt) <= -1) {
          //上传文件格式不正确
          this.$toast.center("不支持您所选的图片格式~");
          return false;
        }

        //toast 启动动画
        this.$loading("上传中...");

        this.imgPreview(this.picValue);
      },

      postImg() {
        var self = this;

        //这里写接口
        var base64 = this.headerImage;
        let param = new FormData(); // 创建form对象
        param.append("imgFile", base64); //对应后台接收图片名

        //判断base64 是否成功, 长度>10
        if (base64.length < 10) {
          //消掉动画
          self.$loading.close();
          self.$toast.center("图片处理失败,请重新选择");
          return false;
        }

        this.post2({
          url: "/Common/UpLoadImage_Base64_2",
          data: param,
          success: function (serve_data) {
            //消掉动画
            self.$loading.close();
            //self.$toast.center('上传成功');
            var pic_url = self.$store.state.url + serve_data;
            self.ayy_pic.push(pic_url);
          },

          error: function (err) {
            //消掉动画
            self.$loading.close();
            self.$toast.center("上传失败,请重新再来");
          },
        });
      },

      imgPreview(file) {
        let self = this;
        let Orientation;
        //去获取拍照时的信息，解决拍出来的照片旋转问题
        Exif.getData(file, function () {
          Orientation = Exif.getTag(this, "Orientation");
        });
        // 看支持不支持FileReader
        if (!file || !window.FileReader) return;
        if (/^image/.test(file.type)) {
          // 创建一个reader
          let reader = new FileReader();
          // 将图片2将转成 base64 格式
          reader.readAsDataURL(file);
          // 读取成功后的回调
          reader.onloadend = function () {
            let result = this.result;
            let img = new Image();
            img.src = result;
            //判断图片是否大于4M,是就直接上传，反之压缩图片
            var pic_size = ((this.result.length * 1.0) / (1024 * 1024)).toFixed(
              2
            );

            if (this.result.length <= 4 * 1024 * 1024) {
              self.headerImage = this.result;

              self.postImg();
            } else {
              img.onload = function () {
                let data = tool.compress(img, Orientation);
                self.headerImage = data;
                self.postImg();
              };
            }
          };
        }
      },
      show_full(url) {
        this.$refs.myFullPic.show(url);
      },
      remove_pic(index) {
        this.ayy_pic.splice(index, 1);
      },
    },
  };
  </script>

  <style lang="scss" scoped>
  .container {
    height: 100vh;
    background-color: #EFEFEF;
  }
  #___file_upload {
    position: absolute;
    left: -999px;
  }

  .content {
    padding: 0 0.8rem;
  }

  .complain-block {
    margin-top: 1rem;
    padding: 1rem 0.8rem;
    border-radius: 1rem;
    background-color: #FDFDFD;
    .font-color {
      font-size: 0.9rem;
      color: #333;
    }
    .describe-block {
      padding: 1rem;
      border-radius: 1rem;
      border: 1px solid #333;
      .describe-text {
        height: 8rem;
        color: #333;
        background: transparent;
        outline: none;
        border: none;
        border-radius: 0.5rem;
        font-size: 0.9rem;
        resize: none;
      }
      .describe-text::placeholder {
        color: #333;
      }
    }
    .note-lb {
      margin-top: 0.5rem;
      span {
        color: #333;
        font-size: 0.65rem;
      }
    }
    .screenshots-block {
      margin-top: 1rem;
      .screenshots-div {
        width: 7.5rem;
        height: 7.5rem;
        margin-top: 1rem;
        margin-right: 0.2rem;
        background: #EFEFEF;
        border-radius: 0.5rem;
        .face-img {
          position: absolute;
          max-width: 5.5rem;
          max-height: 5.5rem;
        }
        .describe-upload-img {
          width: 2rem;
          height: 2rem;
        }
        .describe-upload-name {
          margin-top: 0.5rem;
          font-size: 0.75rem;
          color: #333;
        }
      }
      .remove {
        margin-left: 4rem;
        z-index: 3;
        border-radius: 50%;
        width: 0.9rem;
        height: 0.9rem;
        font-size: 1.3rem;
        background-color: white;
        margin-bottom: 4rem;
        right: 0;
      }
    }
  }

  .gift-tousu-tip{
      padding: 0 .8rem;
      span {
        display: inline-block;
        color: #333;
        margin-top: 1.5rem;
        font-size: 0.65rem;
        a {
          color: #3044fa;
        }
      }
  }

  .line {
    margin-top: 1rem;
    border-top: 1px solid rgba(255,255,255,0.2);
  }

  .submit-btn {
    margin-top: 1rem;
    padding: 0.5rem 8rem;
    border-radius: 1rem;
    background: linear-gradient( 90deg, #8A61FF 13%, #FE9CC0 91%);
    span {
      font-size: 1rem;
      font-weight: bold;
      color: #FFFFFF;
    }
  }

.container-dark {
  background-color: #2f2e33;
  .complain-block {
    background-color: #2c2b30;
    .describe-block {
      border: 1px solid #404040;
      .describe-text {
        color: #fdfdfd;
      }
      .describe-text::placeholder {
        color: #fdfdfd;
      }
    }
    .font-color {
      color: #888;
    }
    .note-lb {
      span {
        color: #888;
      }
    }
    .screenshots-block {
      .screenshots-div {
        background-color: #333;
        .describe-upload-name {
          color: #888;
        }
      }
    }
  }
  .gift-tousu-tip {
      span {
        color: #888;
      }
    }
}
</style>
